import generalCodeMessages from "@/utils/responseMessages/generalCodeMessages"
import sponsorCodeMessages from "@/utils/responseMessages/sponsorCodeMessages"
import numberOfCharMessages from "@/utils/responseMessages/numberOfCharMessages"

export default {
	...generalCodeMessages,
	...sponsorCodeMessages,
	...numberOfCharMessages
}
